import { runtimePaths } from './runtime-paths';

export type PortalArea = 'admin' | 'artist' | 'brand';

export const currentPortalArea = (): PortalArea => {
  if (window.location.pathname.includes('/admin-center')) return 'admin';
  const area = window.location.hash.match(/^#\/(admin|artist|brand)(?:\/|$)/)?.[1];
  return area === 'artist' || area === 'brand' ? area : 'admin';
};

export const configurePortalManifest = () => {
  const area = currentPortalArea();
  let link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'manifest';
    document.head.append(link);
  }
  link.href = `${runtimePaths.publicSite}portal-manifest.webmanifest?area=${area}`;
  let appleIcon = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
  if (!appleIcon) {
    appleIcon = document.createElement('link');
    appleIcon.rel = 'apple-touch-icon';
    document.head.append(appleIcon);
  }
  appleIcon.href = `${runtimePaths.publicSite}portal-next/portal-icons/${area}/icon-192.png`;
  const titles = { admin: '420BRANDS Admin Center', artist: '420BRANDS Artist Center', brand: '420BRANDS Brand Center' };
  document.title = titles[area];
};

export const registerPortalServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) throw new Error('Service Worker werden von diesem Browser nicht unterstuetzt.');
  await navigator.serviceWorker.register(`${runtimePaths.publicSite}portal-sw.js`, { scope: runtimePaths.publicSite });
  return navigator.serviceWorker.ready;
};

export const urlBase64ToUint8Array = (value: string) => {
  const padding = '='.repeat((4 - value.length % 4) % 4);
  const binary = window.atob((value + padding).replace(/-/g, '+').replace(/_/g, '/'));
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return bytes;
};

export const pushSupported = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
export const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches
  || Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
